import { __assign } from "tslib";
import * as React from 'react';
function FileIconLoadingSizeS(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 21 28" }, props),
        React.createElement("path", { d: "M19.6 0H1.4A1.4 1.4 0 000 1.4v25.2A1.4 1.4 0 001.4 28h18.2a1.4 1.4 0 001.4-1.4V1.4A1.4 1.4 0 0019.6 0z" })));
}
export default FileIconLoadingSizeS;
